export default __webpack_public_path__ + "static/media/infernalart_hd.6d3973fc.webp";